/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserDto from './UserDto';

/**
 * The PaginatedUsersDto model module.
 * @module model/PaginatedUsersDto
 * @version v0
 */
class PaginatedUsersDto {
    /**
     * Constructs a new <code>PaginatedUsersDto</code>.
     * @alias module:model/PaginatedUsersDto
     */
    constructor() { 
        
        PaginatedUsersDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedUsersDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedUsersDto} obj Optional instance to populate.
     * @return {module:model/PaginatedUsersDto} The populated <code>PaginatedUsersDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedUsersDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('users')) {
                obj['users'] = ApiClient.convertToType(data['users'], [UserDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedUsersDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedUsersDto</code>.
     */
    static validateJSON(data) {
        if (data['users']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['users'])) {
                throw new Error("Expected the field `users` to be an array in the JSON data but got " + data['users']);
            }
            // validate the optional field `users` (array)
            for (const item of data['users']) {
                UserDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedUsersDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedUsersDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedUsersDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedUsersDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/UserDto>} users
 */
PaginatedUsersDto.prototype['users'] = undefined;






export default PaginatedUsersDto;

